import React, { useState } from 'react'
import { ActivityTypeProvider } from './Hooks/ActivityTypeContext.js'
import LoginForm from './Modules/LoginForm.jsx'
import ChallengeChoice from './Modules/ChallengeChoice.jsx'
import ChallengeQuestion from './Modules/ChallengeQuestion.jsx'
import ChangePassword from './Modules/ChangePassword.jsx'
import OneTimePasscode from './Modules/OneTimePasscode.jsx'
import CapturePhoneNumber from './Modules/CapturePhoneNumber.jsx'
import VerifyPhoneNumber from './Modules/VerifyPhoneNumber.jsx'
import DSTAccess from './Static/DSTAccess.jsx'
import {
  CHANGE_PASSWORD_SUCCESS,
  FORM_NAME_CHALLENGE_CHOICE,
  FORM_NAME_CHALLENGE_QUESTION,
  FORM_NAME_CHANGE_PASSWORD,
  FORM_NAME_LOGIN_FORM,
  FORM_NAME_ONE_TIME_PASSCODE,
  MFA_ANSWERED,
  PASSWORD_MODE,
  FORM_NAME_CAPTURE_PHONE_NUMBER,
  FORM_NAME_VERIFY_PHONE_NUMBER,
} from './Helpers/LoginHelper.js'
import { useLoginInputHook } from './Hooks/LoginInputHook.js'
import { usePasswordInputHook } from './Hooks/PasswordInputHook.js'
import { generateUID } from '../../spa/utility/threatMetrix/TMX.js'

function Login({ tmx_id }) {
  const loginInputHook = useLoginInputHook()
  const passwordInputHook = usePasswordInputHook()
  const [displayForm, setDisplayForm] = useState(FORM_NAME_LOGIN_FORM)
  const [mfaData, setMfaData] = useState(null)
  const [otpDta, setOtpData] = useState(null)
  const [challengeQuestionData, setChallengeQuestionData] = useState(null)
  const [loginState, setLoginState] = useState(null)
  const [changePasswordData, setChangePasswordData] = useState(null)
  const [phoneNbr, setPhoneNbr] = useState(null)
  const [newPhoneNumber, setNewPhoneNumber] = useState(false)
  const [corelationId, setCorelationId] = useState({
    app_corelation_id: '',
    wam_corelation_id: '',
  })
  const websession_id = `web_session_${generateUID()}`

  const handleDisplayChange = (display, data) => {
    if (display === FORM_NAME_LOGIN_FORM) {
      setDisplayForm(display)
    }

    if (display === FORM_NAME_CHALLENGE_CHOICE) {
      setDisplayForm(display)
      if (data) {
        setMfaData(data)
        setPhoneNbr(data.value.userVrfPhoneNbr)
      }
    }

    if (display === FORM_NAME_ONE_TIME_PASSCODE) {
      setDisplayForm(display)
      setOtpData(data)
    }

    if (display === FORM_NAME_CHALLENGE_QUESTION) {
      setDisplayForm(display)
      setChallengeQuestionData(data)
    }

    if (display === MFA_ANSWERED) {
      setDisplayForm(FORM_NAME_LOGIN_FORM)
      setLoginState(data)
    }

    if (display === FORM_NAME_CHANGE_PASSWORD) {
      setDisplayForm(FORM_NAME_CHANGE_PASSWORD)
      setChangePasswordData(data)
    }

    if (display === CHANGE_PASSWORD_SUCCESS) {
      setDisplayForm(FORM_NAME_LOGIN_FORM)
      setLoginState(data)
    }

    if (display === FORM_NAME_CAPTURE_PHONE_NUMBER) {
      setDisplayForm(display)
      setPhoneNbr(data)
    }

    if (display === FORM_NAME_VERIFY_PHONE_NUMBER) {
      setDisplayForm(display)
      if (data) {
        setPhoneNbr(data.phoneNumber)
        setNewPhoneNumber(data.updatePhoneNumber)
      }
    }
  }

  return (
    <ActivityTypeProvider>
      <div className="u-sizeConstrained">
        <div className="u-marginTop10gu u-marginBottom4gu">
          <h2 className="u-paddingBottom2gu u-borderBottom u-inlineBlock u-borderBottomColorBrandLighter">
            Log in: Financial professionals
          </h2>
        </div>
      </div>
      <div className="u-bgColorLightest u-borderColorNeutralLight u-borderBottom u-borderTop u-borderLeft0 u-borderRight0 u-padding8gu u-marginBottom10gu">
        <div className="u-sizeConstrained">
          {displayForm === FORM_NAME_LOGIN_FORM && (
            <LoginForm
              handleDisplayChange={handleDisplayChange}
              loginInputHook={loginInputHook}
              usePasswordInputHook={passwordInputHook}
              loginState={loginState}
              tmx_id={tmx_id}
              websession_id={websession_id}
              setCorelationId={setCorelationId}
            />
          )}

          {/*
        Login.hideContent();
        $(".challenge-choice-content").removeClass("hide").show();
      */}
          {displayForm === FORM_NAME_CHALLENGE_CHOICE && (
            <ChallengeChoice
              handleDisplayChange={handleDisplayChange}
              mfaResponseData={mfaData}
              phoneNumber={phoneNbr}
            />
          )}

          {/*
      Login.hideContent();
        $(".challenge-question-content").removeClass("hide").show()
      */}
          {displayForm === FORM_NAME_CHALLENGE_QUESTION && (
            <ChallengeQuestion
              handleDisplayChange={handleDisplayChange}
              challengeQuestionData={challengeQuestionData}
            />
          )}

          {/*
        Login.hideContent();
        $(".one-time-passcode-content").removeClass("hide").show();
        */}

          {displayForm === FORM_NAME_ONE_TIME_PASSCODE && (
            <OneTimePasscode
              handleDisplayChange={handleDisplayChange}
              otpData={otpDta}
              loginInputHook={loginInputHook}
              passwordInputHook={passwordInputHook}
              phoneNumber={phoneNbr}
              tmx_id={tmx_id}
              websession_id={websession_id}
              corelationId={corelationId}
            />
          )}

          {/*
      Login.hideContent();
      $(".change-password-content").removeClass("hide").show();
      */}
          {displayForm === FORM_NAME_CHANGE_PASSWORD && (
            <ChangePassword
              handleDisplayChange={handleDisplayChange}
              changePasswordData={changePasswordData}
              passwordMode={PASSWORD_MODE.TEMP_PASSWORD}
              loginInputHook={loginInputHook}
            />
          )}
          {displayForm === FORM_NAME_CAPTURE_PHONE_NUMBER && (
            <CapturePhoneNumber
              handleDisplayChange={handleDisplayChange}
              existingPhoneNumber={phoneNbr}
            />
          )}

          {displayForm === FORM_NAME_VERIFY_PHONE_NUMBER && (
            <VerifyPhoneNumber
              handleDisplayChange={handleDisplayChange}
              phoneNumber={phoneNbr}
              newPhoneNumber={newPhoneNumber}
              loginInputHook={loginInputHook}
              passwordInputHook={passwordInputHook}
            />
          )}
        </div>
      </div>
      {/*
        $(".login-content").hide()
        $(".security-questions-content").removeClass("hide").show();
        */}
      {/* <SecurityQuestions /> */}
      <DSTAccess />
    </ActivityTypeProvider>
  )
}

Login.propTypes = {}

export default Login
